<ng-template #nolist>
  <div class="empty-state">
    <span class="mdi mdi-trending-up mdi-48px"></span>
    <h3>Welkom in Groeimeter!</h3>
    <p>Je begint met Groeimeter met het maken van een leerlijn.</p>
    <ng-container *ngIf="!onboardingDisabled">
      <p>
        <a (click)="openModal('onboarding')" class="btn btn-outline-primary"
          ><strong>Start</strong></a
        >
        met het maken van een leerlijn.
      </p>
    </ng-container>
    <ng-container *ngIf="onboardingDisabled">
      <p>
        <a
          (click)="createLearningObjectiveOrder()"
          class="btn btn-outline-primary"
          ><strong>Start</strong></a
        >
        met het maken van een leerlijn.
      </p>
    </ng-container>
    <a
      href="https://citolabgroeimeter.wixsite.com/hoewerktgroeimeter"
      target="_new"
      >Open de handleiding in een nieuw venster.</a
    >
  </div>
</ng-template>

<ng-template #LoadingDataState>
  <div class="empty-state">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <h4 class="mt-3">Data ophalen</h4>
  </div>
</ng-template>

<ng-template #LoadingOrders>
  <div class="empty-state">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <h4 class="mt-3">Leerdoellijsten laden</h4>
  </div>
</ng-template>

<ng-template #LoadingLOData>
  <div class="empty-state">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <h4 class="mt-3">Leerdoelen laden</h4>
  </div>
</ng-template>

<ng-template #LoadingSelectedOrder>
  <div class="empty-state">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <h4 class="mt-3">Leerdoellijst selecteren</h4>
  </div>
</ng-template>

<ng-template #LoadingAssignments>
  <div class="empty-state">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <h4 class="mt-3">Opdrachten laden</h4>
  </div>
</ng-template>

<ng-template #LoadingSelectedLO>
  <div class="empty-state">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <h4 class="mt-3">Leerdoelen selecteren</h4>
  </div>
</ng-template>

<ng-template #noPages>
  <div class="no-pages">
    <h3>Er is op dit moment geen onboarding beschikbaar</h3>
    <a
      class="closebtn text-info bg-white btn"
      (click)="closeModalNoPages('onboarding')"
      >Close</a
    >
  </div>
</ng-template>

<ng-container *ngIf="dataState$ | async as dataState; else LoadingDataState">
  <ng-container *ngIf="dataState.loaded; else LoadingDataState">
    <ng-container
      *ngIf="
        learningObjectiveOrders$ | async as learningObjectiveOrders;
        else LoadingOrders
      "
    >
      <ng-container
        *ngIf="
          learningObjectiveData$ | async as learningObjectiveData;
          else LoadingLOData
        "
      >
        <ng-container
          *ngIf="
            learningObjectiveData.isLoading ||
              (learningObjectiveData.hasLists &&
                !learningObjectiveData.isLoading);
            else nolist
          "
        >
          <!-- <ng-container *ngIf="learningObjectiveData.selectedLearningObjectiveOrder; else LoadingSelectedOrder"> -->
          <ng-container
            *ngIf="
              assignmentsPerLearningObjective$
                | async as assignmentsPerLearningObjective;
              else LoadingAssignments
            "
          >
            <ng-container
              *ngIf="
                selectedLearningObjective$ | async as selectedLearningObjective;
                else LoadingSelectedLO
              "
            >
              <ng-container
                *ngIf="visibleAssignments$ | async as visibleAssignments"
              >
                <ng-container
                  *ngIf="uniqueYearGroups$ | async as candidateYears"
                >
                  <ng-container
                    *ngIf="uniqueClassGroups$ | async as candidateClasses"
                  >
                    <div
                      class="grid-container"
                      style="transform-style: preserve-3d"
                    >
                      <div class="grid-switch-button p-3">
                        <button
                          class="btn btn-lg bg-primary text-white mdi mdi-chevron-left"
                          [routerLink]="['/domains']"
                        >
                          Leerdoellijsten
                        </button>

                        <button
                          class="ml-3 btn btn-lg bg-primary text-white"
                          [routerLink]="['/dashboard']"
                        >
                          Startpagina
                        </button>
                      </div>

                      <div class="grid-brand-account p-3 d-flex">
                        <button class="btn btn-none" (click)="openInfoPage()">
                          <div class="text-primary">
                            Groeimeter hoe werkt het?
                          </div>
                          <div class="small text-secondary">Handleiding</div>
                        </button>
                        <div class="nav-item ml-auto">
                          <app-navbar
                            [groupName]="groupname$ | async"
                          ></app-navbar>
                        </div>
                      </div>

                      <div class="grid-major-subject p-3 bg-white">
                        <div class="d-flex align-items-baseline">
                          <ng-container
                            *ngIf="
                              (selectedCitoModule$ | async) ===
                              citomodules.Rekenen
                            "
                          >
                            <button
                              type="button"
                              (click)="
                                showInStructure(
                                  selectedLearningObjective.ref.domainId,
                                  selectedLearningObjective.ref
                                )
                              "
                              [class.disabled]="!selectedLearningObjective.ref"
                              [class.shadow-sm]="selectedLearningObjective.ref"
                              class="btn btn-gray-light mr-3"
                            >
                              Toon in structuur
                            </button>
                          </ng-container>
                          <button
                            type="button"
                            (click)="
                              showInfo(selectedLearningObjective.ref.code)
                            "
                            [class.disabled]="!selectedLearningObjective.ref"
                            [class.shadow-sm]="selectedLearningObjective.ref"
                            class="btn btn-gray-light mr-3"
                          >
                            Leerdoelinfo
                          </button>

                          <div class="btn-group ml-auto" dropdown>
                            <button
                              id="button-basic"
                              dropdownToggle
                              type="button"
                              class="btn btn-gray-light"
                              aria-controls="dropdown-basic"
                            >
                              Plannen
                              <span class="ml-3 mdi mdi-chevron-down"></span>
                            </button>
                            <ul
                              id="dropdown-basic"
                              *dropdownMenu
                              class="dropdown-menu"
                              role="menu"
                              aria-labelledby="button-basic"
                            >
                              <li
                                role="menuitem"
                                (click)="
                                  planLearningObjective(
                                    selectedLearningObjective.ref.id
                                  )
                                "
                                [class.disabled]="
                                  !selectedLearningObjective.ref
                                "
                              >
                                <a
                                  class="dropdown-item"
                                  [class.disabled]="
                                    !selectedLearningObjective.ref
                                  "
                                  href="javascript:void(0)"
                                  >Groep plannen</a
                                >
                              </li>
                              <li
                                role="menuitem"
                                (click)="
                                  unplanLearningObjective(
                                    selectedLearningObjective.ref.id
                                  )
                                "
                                [class.disabled]="
                                  !selectedLearningObjective.ref
                                "
                              >
                                <a
                                  class="dropdown-item"
                                  [class.disabled]="
                                    !selectedLearningObjective.ref
                                  "
                                  href="javascript:void(0)"
                                  >Groep ontplannen</a
                                >
                              </li>
                              <li
                                role="menuitem"
                                (click)="
                                  planSelection(
                                    visibleAssignments,
                                    learningObjectiveData.learningObjectivesInList,
                                    true
                                  )
                                "
                              >
                                <a
                                  class="dropdown-item"
                                  href="javascript:void(0)"
                                  >Alles plannen</a
                                >
                              </li>
                              <li
                                role="menuitem"
                                (click)="
                                  planSelection(
                                    visibleAssignments,
                                    learningObjectiveData.learningObjectivesInList,
                                    false
                                  )
                                "
                              >
                                <a
                                  class="dropdown-item"
                                  href="javascript:void(0)"
                                  >Alles ontplannen</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div
                        class="grid-buttons p-3 bg-white"
                        aria-label="Toolbar with button groups"
                      >
                        <app-horizontal-filters> </app-horizontal-filters>
                      </div>

                      <app-search
                        class="spacer border-bottom"
                        [placeholdertext]="
                          learningObjectiveData.selectedLearningObjectiveOrder
                            ? learningObjectiveData
                                .selectedLearningObjectiveOrder.title
                            : 'Selecteer een lijst'
                        "
                      ></app-search>

                      <div
                        class="grid-filters p-3 bg-white border-right d-flex"
                        style="z-index: 1000"
                      >
                        <app-filters
                          class="w-100"
                          [placeholdertext]="
                            learningObjectiveData.selectedLearningObjectiveOrder
                              ? learningObjectiveData
                                  .selectedLearningObjectiveOrder.title
                              : 'Selecteer een lijst'
                          "
                        >
                        </app-filters>

                        <!-- <div class="dropdown"
                             dropdown style="height: 40px;">
                          <a class="btn btn-link p-0 pl-2 text-primary border-0 mdi-22px mdi mdi-chevron-down-box"
                             dropdownToggle>
                          </a>
                          <ul *dropdownMenu
                              class="dropdown-menu"
                              role="menu"
                              aria-labelledby="lopicker-button">
                            <li (click)="setSelectedLearningObjectiveOrder(learningObjectiveOrder.id)"
                                role="menuitem"
                                [class.active]="learningObjectiveOrder.id === learningObjectiveData.selectedLearningObjectiveOrder?.id"
                                *ngFor="let learningObjectiveOrder of learningObjectiveOrders.myLists;"
                                class="dropdown-item c-pointer">
                              {{ learningObjectiveOrder.title }}
                            </li>
                          </ul>
                        </div> -->
                      </div>

                      <div class="grid-header border-bottom">
                        <div
                          class="candidates py-4 d-flex align-items-center"
                          appScrollWithElement
                          [listenToScrollElement]="virtualScroll"
                          id="candidates"
                        >
                          <app-candidate-list
                            [candidates]="candidates$ | async"
                            (selectCandidate)="showSingleCandidate($event)"
                          >
                          </app-candidate-list>
                        </div>
                      </div>

                      <virtual-scroll
                        appScrollFixArea
                        class="grid-learningobjectives overflow-scroll"
                        #virtualScroll="virtualScroll"
                        [items]="learningObjectiveData.learningObjectivesInList"
                        (update)="viewPortLearningObjectives = $event"
                      >
                        <div
                          class="overlay position-absolute"
                          style="width: 400px; margin-left: 0"
                          [style.left.px]="leftpopup - 113"
                          [style.top.px]="toppopup + 52"
                        >
                          <ng-container *ngIf="options$ | async as options">
                            <app-assign-status
                              *ngIf="options?.assignStatusOpened"
                            >
                            </app-assign-status>
                          </ng-container>
                        </div>

                        <div
                          class="content d-flex"
                          style="height: 5rem"
                          *ngFor="
                            let learningObjective of viewPortLearningObjectives;
                            let i = index;
                            trackBy: trackEntity
                          "
                          style="flex-wrap: nowrap"
                          [class.bg-white]="
                            selectedLearningObjective.ref
                              ? selectedLearningObjective.ref.id ===
                                learningObjective.id
                              : false
                          "
                        >
                          <div
                            class="d-flex"
                            style="
                              z-index: 10;
                              width: 400px;
                              min-width: 400px;
                              max-width: 400px;
                            "
                            [ngClass]="
                              selectedLearningObjective.ref &&
                              selectedLearningObjective.ref.id ===
                                learningObjective.id
                                ? 'active-bg'
                                : 'bg-white'
                            "
                            appScrollFixLeft
                          >
                            <app-learning-objective-view
                              style="
                                height: 6rem;
                                max-height: 6rem;
                                overflow: hidden;
                              "
                              class="py-2 border-bottom c-pointer"
                              [selected]="
                                selectedLearningObjective.ref
                                  ? selectedLearningObjective.ref.id ===
                                    learningObjective.id
                                  : false
                              "
                              [learningObjective]="learningObjective"
                              (selectLearningObjective)="
                                learningObjectiveClick(
                                  learningObjective,
                                  selectedLearningObjective.ref
                                    ? selectedLearningObjective.ref.id ===
                                        learningObjective.id
                                    : false
                                )
                              "
                            >
                            </app-learning-objective-view>
                          </div>
                          <div class="d-flex">
                            <app-assignment-indicator
                              (cellclick)="clickCell(assignment, $event)"
                              *ngFor="
                                let assignment of assignmentsPerLearningObjective[
                                  learningObjective.id
                                ]
                              "
                              [ngClass]="{
                                candidateLeft: assignment.candidateLeft
                              }"
                              [assignment]="assignment"
                            ></app-assignment-indicator>
                          </div>
                        </div>
                      </virtual-scroll>

                      <div
                        class="grid-candidate-progress"
                        style="pointer-events: none; z-index: 100"
                      >
                        <router-outlet
                          class="candidate-info"
                          name="candidateprogress"
                        ></router-outlet>
                      </div>
                      <div
                        class="grid-learningobjective-info"
                        style="pointer-events: none; z-index: 1050"
                      >
                        <router-outlet></router-outlet>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
  <!-- </ng-container> -->

  <ng-container>
    <jw-modal (onClose)="setUserReadNotes($event)" id="changelogs">
      <ng-container *ngIf="releaseNotes">
        <div
          class="container-fluid"
          [innerHTML]="releaseNotes | safeHtml"
        ></div>
      </ng-container>
      <ng-container *ngIf="!releaseNotes">
        <div class="loader-container">
          <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </ng-container>
      <div class="wrapper">
        <a
          class="closebtn text-info bg-white btn"
          (click)="closeModalNotes('changelogs')"
          >Sluiten</a
        >
      </div>
    </jw-modal>
  </ng-container>

  <jw-modal (onClose)="setUserSeenOnboarding($event)" id="onboarding">
    <ng-container
      *ngIf="onboarding && onboarding.onboardingPages.length; else noPages"
    >
      <div
        class="container-fluid"
        [innerHTML]="onboarding.onboardingPages[activePage].html | safeHtml"
      ></div>
      <div class="pagination">
        <button [disabled]="activePage == 0" (click)="prevButtonClick()">
          Vorige
        </button>
        <button
          [disabled]="activePage == onboarding.onboardingPages.length - 1"
          (click)="nextButtonClick()"
        >
          Volgende
        </button>
      </div>
    </ng-container>
    <div class="wrapper">
      <div class="check-wrapper">
        <input
          type="checkbox"
          id="dontshowagain"
          name="dontshowagain"
          [checked]="dontshowagain"
          (change)="dontshowagain = !dontshowagain"
        />
        <label for="dontshowagain">
          Vink aan als je de handleiding niet wilt zien als je opnieuw inlogt.
        </label>
      </div>
      <a
        class="closebtn text-info bg-white btn"
        (click)="closeModalOnboarding('onboarding')"
        >Sluiten</a
      >
    </div>
  </jw-modal>
</ng-container>
